import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// reactstrap components
import { Button, Card, CardBody } from "reactstrap";

import AuthService from "../../../../services/auth-api";
import { LightThemedButton, ThemedButton } from "@/components/ThemedButton";
import { Container, Group } from "@mantine/core";
import { TitleContainer } from "@/components/HeaderContainer";
import useLoginSession from "@/hooks/useLoginSession";

function ProfileEdit() {
	const { isLoginBySession, postSuccess, postErrorMessage } = useLoginSession();
	const { user: userData } = useSelector((state) => state.auth);
	const currentUser = userData.user;
	let navigate = useNavigate();
	const [loading, setLoading] = useState(false);

	const handleSendOTP = () => {
		setLoading(true);
		AuthService.forgetEmailSendOtp(
			currentUser.learnermaster_email ? currentUser.learnermaster_email : "",
		)
			.then(
				() => {
					navigate("/profile/change-email/otp-validation");
				},
				() => {},
			)
			.catch(() => {
				setLoading(false);
			});
	};

	return (
		<>
			<Container>
				<TitleContainer>{"Change Email"}</TitleContainer>
				<Card className='border-0 mt-2 mx-auto' style={{ maxWidth: "600px" }}>
					<CardBody className='px-lg-5 py-lg-5 text-center'>
						<div className=''>
							<p>
								{
									"Email verification are required before you can change your email. An OTP verification code will be send to your email."
								}
							</p>
						</div>
						<Group justify='center' mt={20}>
							<LightThemedButton
								onClick={() => {
									if (isLoginBySession) {
										postErrorMessage("Cancelled By User");
									} else {
										navigate(-1);
									}
								}}>
								Cancel
							</LightThemedButton>
							<ThemedButton onClick={handleSendOTP} disabled={loading} loading={loading}>
								Send OTP
							</ThemedButton>
						</Group>
					</CardBody>
				</Card>
			</Container>
		</>
	);
}

export default ProfileEdit;
